import React from "react";

export const Icon = ({ name, size, color, className, style }) => (
  <span
    className={`icon-${name} ${className || ""}`}
    style={{ ...style, color, fontSize: size }}
  />
);
